module.exports = __webpack_public_path__ + "img/behind the firepower.d1fd55a2.png";